module.exports = __webpack_public_path__ + "img/4.195dd45b.jpg";